import { t } from 'i18next'
import { AvailabilityItem, AvailabilityWrapper } from './types'

export function getAvailabilityItem(
    available: string | null | undefined,
    colorHexTxt: string = 'black',
    isSupplier: boolean = false
): AvailabilityItem {
    const supplierText = isSupplier
        ? ` ${t('eshop.productlist.table.at_supplier')}`
        : ''

    const numericQuantity = Number(available)

    if (Number.isNaN(numericQuantity)) {
        return {
            available: `${available || 'Unavailable'}${supplierText}`,
            colorHexTxt,
        }
    }

    return {
        available:
            numericQuantity === 0
                ? t('eshop.productlist.table.outOfStock')
                : `${t(
                      'eshop.productlist.table.inStock'
                  )} ${numericQuantity} ${t(
                      'eshop.productlist.table.pieces'
                  )}${supplierText}`,
        colorHexTxt: numericQuantity === 0 ? '#f39205' : '#72af53',
    }
}

export function getAvailabilityWrapper(
    available: string,
    colorHexTxt: string,
    availableInStore?: string,
    colorHexTxtInStore?: string
): AvailabilityWrapper {
    const availabilities: AvailabilityWrapper = {}

    if (!availableInStore) {
        availabilities.main = getAvailabilityItem(available, colorHexTxt)
    } else {
        availabilities.main = getAvailabilityItem(
            availableInStore,
            colorHexTxtInStore ?? colorHexTxt
        )
        availabilities.external = getAvailabilityItem(
            available,
            colorHexTxt,
            true
        )
    }

    return availabilities
}
